import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import PageLayout from "./common/PageApp";
import "../../Home.css";
import { useLocation } from "react-router-dom";
import { saveContactMessage } from "../../service/api";
import { toast } from "react-toastify";

const ContactUs = () => {
  const location = useLocation();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await saveContactMessage(formData);
      console.log("Response:", res.data);

      toast.success(res.data.message);

      setFormData({
        name: "",
        email: "",
        phone: "",
        message: "",
      });
    } catch (error) {
      console.error("Error:", error);
      toast.error("Something went wrong");
    }
  };

  return (
    <PageLayout>
      <section className="innerBnrNav">
        <div className="bnrNav">
          <div className="site-width">
            <div className="bnrNavWrap">
              <ul>
                <li>
                  <a href="/">Home</a>
                </li>
                <li>
                  <a href="javascript:void(0)">Contact Us</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="contact-content pt-50 pb-50">
        <div className="site-width">
          <div className="titleSection text-center wow animate__fadeInDown">
            <h2>Contact Us</h2>
            <p>
              We’re here to help you every step of the way—whether you’re an
              employer looking to hire flexible talent or a job seeker searching
              for the right opportunity. At <strong>Hourlee</strong>, our
              support team is always ready to answer your queries and guide you
              through the process.
            </p>
          </div>

          <div className="row contact-wrapper">
            {/* Info */}
            <div className="col-lg-5 contact-info">
              <div className="info-item">
                <div>
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/img/telephone.png`}
                    alt="img"
                  />
                </div>
                <div>
                  <h4>Phone Support</h4>
                  <p>+91-9811999641</p>
                </div>
              </div>

              <div className="info-item">
                <div>
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/img/email.png`}
                    alt="img"
                  />
                </div>
                <div>
                  <h4>Email US</h4>
                  <p>contact@hourlee.in</p>
                </div>
              </div>

              <div className="info-item">
                <div>
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/img/location.png`}
                    alt="img"
                  />
                </div>
                <div>
                  <h4>Office Address</h4>
                  <p>124, First Floor, Westend Mall, Janakpuri West – 110058</p>
                </div>
              </div>

              <p>
                You can also reach us on our social platforms for quick updates,
                announcements, and support:
              </p>

              <div className="social-links">
                <a href="#">Facebook</a>
                <a href="#">LinkedIn</a>
                <a href="#">Instagram</a>
                <a href="#">Twitter/X</a>
              </div>
            </div>

            {/* Message Box */}
            <div className="col-lg-7">
              <div className="contact-wrapper">
                <div className="contact-info">
                  <p>
                    Our goal is to ensure your journey with Hourlee is smooth,
                    transparent, and hassle-free. Don’t hesitate to reach
                    out—we’d love to hear from you!
                  </p>
                  <form className="hj-form" onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-md-12 mb-3">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter your name"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          required
                        />
                      </div>

                      <div className="col-md-6 mb-3">
                        <input
                          type="email"
                          className="form-control"
                          placeholder="Enter your email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          required
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter your phone number"
                          name="phone"
                          value={formData.phone}
                          onChange={handleChange}
                          required
                          maxlength="10"
                          minlength="10"
                        />
                      </div>
                    </div>

                    <div className="mb-4">
                      <textarea
                        className="form-control"
                        rows="4"
                        placeholder="Write your message"
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        required
                      ></textarea>
                    </div>

                    <button
                      type="submit"
                      className="btn px-4"
                      style={{ backgroundColor: "#ff6600", color: "#fff" }}
                    >
                      Submit Message
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </PageLayout>
  );
};

export default ContactUs;
